import React from "react";
import { IEmployeeGroup } from "../../domain/employeeGroups/IEmployeeGroup";
import { BaseComponent } from "../core/BaseComponent";

export interface EmployeeGroupListTableRowProps {
    employeeGroup: IEmployeeGroup;
    onClick: () => void;
    onRemove: () => void;
}

export class EmployeeGroupListTableRow extends BaseComponent<EmployeeGroupListTableRowProps> {
    render() {
        const employeeGroup = this.props.employeeGroup;

        return <tr>
            <td className="dagcell clickable" onClick={this.props.onClick}>{employeeGroup.name}</td>
            <td className="dagcell clickable" onClick={this.props.onClick}>{employeeGroup.sortOrder}</td>
            <td className="dagcell clickable" onClick={this.props.onClick}>{employeeGroup.links.length}</td>
            <td className="dagcell clickable" onClick={this.props.onRemove}>{this.translate(`employeeGroup.remove`)}</td>
        </tr>;
    }
}
